<template>
  <span
    class="jps-tag jps-dark jps-search-subquery generated-3"
    @click="emits('edit')"
    tabindex="0"
  >
    <UiButtonIcon
      v-if="!unmodifiable"
      class="jps-text-button jps-sub-orange is-size-6"
      icon="mdi/pencil"
    />
    <span>{{ subQuery.c }}</span>
    <SearchQuerySpan :q="subQuery.q" :cs="cs" :hide-cs="true" />
    <UiButtonIcon
      v-if="!unmodifiable"
      tag="button"
      class="jps-text-button jps-sub-orange is-size-6"
      @click.stop="emits('delete')"
      icon="mdi/close-circle"
    />
  </span>
</template>

<script lang="ts" setup>
interface Props {
  unmodifiable?: Boolean
  subQuery: SubQuery | CustomSearchConstraint
  cs: CustomSearchDefinition
}
const props = withDefaults(defineProps<Props>(), {
})
const emits = defineEmits(['edit', 'delete'])
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-search-subquery {
  border-radius: 9999px;
  border-width: 1px;
  border-style: solid;
  border-collapse: separate;
  background-color: white;
  background: $white;
  font-size: 0.875rem;
  display: flex;
  gap: 4px;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  padding-left: 0.25rem;
  padding-right: 0.175rem;
  button {
    line-height: 1.5rem;
  }
  .jps-query-span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.generated-3 {
  display: inline-flex;
  align-items: center;
}
</style>
